import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import AddServiceLayer from "./AddServiceLayer";


const AddServicePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add Service" />

        {/* AddUserLayer */}
        <AddServiceLayer />


      </MasterLayout>
    </>
  );
};

export default AddServicePage;
